import { PencilRuler } from 'lucide-react';
import styles from './draftStatus.module.css';

interface DraftBannerProps {
  onSync: () => void;
  title: string;
  body: string;
}

export function DraftBanner({ onSync, title, body }: DraftBannerProps) {
  return (
    <section className={styles.banner}>
      <span className={styles.bannerIcon}>
        <PencilRuler aria-hidden="true" />
      </span>
      <div className={styles.bannerBody}>
        <p className={styles.bannerTitle}>{title}</p>
        <p className={styles.bannerText}>{body}</p>
      </div>
      <button type="button" className={styles.bannerAction} onClick={onSync}>
        Sync to tenants
      </button>
    </section>
  );
}
